import { GenderSportEnum } from 'queries';
import GENDER_SPORTS from 'constants/GenderSports';
import BASEBALL_COVER_IMAGE from 'images/sports/covers/baseball.png';
import BASKETBALL_COVER_IMAGE from 'images/sports/covers/basketball.png';
import BEACH_VOLLEYBALL_COVER_IMAGE from 'images/sports/covers/beach-volleyball.png';
import CROSS_COUNTRY_COVER_IMAGE from 'images/sports/covers/cross-country.png';
import FIELD_HOCKEY_COVER_IMAGE from 'images/sports/covers/field-hockey.png';
import FLAG_FOOTBALL_COVER_IMAGE from 'images/sports/covers/flag-football.png';
import FOOTBALL_COVER_IMAGE from 'images/sports/covers/football.png';
import GOLF_COVER_IMAGE from 'images/sports/covers/golf.png';
import ICE_HOCKEY_COVER_IMAGE from 'images/sports/covers/ice-hockey.png';
import LACROSSE_COVER_IMAGE from 'images/sports/covers/lacrosse.png';
import SOCCER_COVER_IMAGE from 'images/sports/covers/soccer.png';
import SOFTBALL_COVER_IMAGE from 'images/sports/covers/softball.png';
import TENNIS_COVER_IMAGE from 'images/sports/covers/tennis.png';
import VOLLEYBALL_COVER_IMAGE from 'images/sports/covers/volleyball.png';
import WATER_POLO_COVER_IMAGE from 'images/sports/covers/water-polo.png';
import WRESTLING_COVER_IMAGE from 'images/sports/covers/wrestling.png';

import {
  BASEBALL,
  BASKETBALL,
  BEACH_VOLLEYBALL,
  CROSS_COUNTRY,
  FIELD_HOCKEY,
  FLAG_FOOTBALL,
  FOOTBALL,
  GOLF,
  ICE_HOCKEY,
  LACROSSE,
  SOCCER,
  SOFTBALL,
  TENNIS,
  UNIFIED_BASKETBALL,
  VOLLEYBALL,
  WATER_POLO,
  WRESTLING
} from 'constants/Sports';
import Image, { ImageProps } from 'components/Image';
import { DEFAULT_COVER_IMAGE } from 'constants.js.erb';

export function getGenderSportCoverImageSrc(genderSportEnum: GenderSportEnum) {
  const genderSport = GENDER_SPORTS.find(genderSport => genderSport.key === genderSportEnum)!;

  switch (genderSport.sportId) {
    case BASKETBALL:
      return BASKETBALL_COVER_IMAGE;
    case FOOTBALL:
      return FOOTBALL_COVER_IMAGE;
    case BASEBALL:
      return BASEBALL_COVER_IMAGE;
    case SOFTBALL:
      return SOFTBALL_COVER_IMAGE;
    case LACROSSE:
      return LACROSSE_COVER_IMAGE;
    case SOCCER:
      return SOCCER_COVER_IMAGE;
    case VOLLEYBALL:
      return VOLLEYBALL_COVER_IMAGE;
    case FIELD_HOCKEY:
      return FIELD_HOCKEY_COVER_IMAGE;
    case ICE_HOCKEY:
      return ICE_HOCKEY_COVER_IMAGE;
    case WATER_POLO:
      return WATER_POLO_COVER_IMAGE;
    case CROSS_COUNTRY:
      return CROSS_COUNTRY_COVER_IMAGE;
    case GOLF:
      return GOLF_COVER_IMAGE;
    case TENNIS:
      return TENNIS_COVER_IMAGE;
    case WRESTLING:
      return WRESTLING_COVER_IMAGE;
    case BEACH_VOLLEYBALL:
      return BEACH_VOLLEYBALL_COVER_IMAGE;
    case FLAG_FOOTBALL:
      return FLAG_FOOTBALL_COVER_IMAGE;
    case UNIFIED_BASKETBALL:
      return BASKETBALL_COVER_IMAGE;
    default:
      return DEFAULT_COVER_IMAGE;
  }
}

export default function GenderSportCoverImage({
  genderSport,
  className,
  ...props
}: {
  genderSport: {
    key: GenderSportEnum;
    name: string;
  };
} & ImageProps) {
  return <Image src={getGenderSportCoverImageSrc(genderSport.key)} alt={genderSport.name} className={className} {...props} />;
}
